import { render, staticRenderFns } from "./TrainingView.vue?vue&type=template&id=a3a7121e&scoped=true"
import script from "./TrainingView.vue?vue&type=script&lang=js"
export * from "./TrainingView.vue?vue&type=script&lang=js"
import style0 from "./TrainingView.vue?vue&type=style&index=0&id=a3a7121e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a7121e",
  null
  
)

export default component.exports